import config from 'config'
import { Stakeholder } from 'models'
import { fleetview } from '../fleetview'
import { buildQueryString } from 'utils'
import { QueryOptions, ListResult } from 'interfaces/queryOptions'

export async function list(
  options: QueryOptions = {}
): Promise<ListResult<Stakeholder>> {
  options.count = options.count ?? true
  options.limit = options.limit ?? config.items_per_list_page

  const optionString = buildQueryString(options)

  const response = await fleetview.get(
    `/v5/billing/stakeholders${optionString}`
  )
  return response.data
}

export async function search(
  search: string
): Promise<{ value: number; label: string }[]> {
  const result = await list({
    attributes: ['corporate_name'],
    search
  })

  return result.data.map((stakeholder: any) => ({
    value: stakeholder.id,
    label: stakeholder.attributes.corporate_name ?? ''
  }))
}
